module.exports = __webpack_public_path__ + "static/img/silhouette-2.ea30713.svg";